import {SERVICE_MODULE_TYPES} from '@/pages/service-modules/grid-components/ServiceModuleCard'
import {File} from 'lucide-react'
import type {ServiceModuleModel} from "@/api/model";
import {Tooltip, TooltipContent, TooltipTrigger} from "@/components/shadcn/tooltip.tsx";
import {iconForName} from "@/components/common/iconByName.tsx";

export function ServiceModuleIcon({module}: { module: ServiceModuleModel }) {
  const typeEntry = SERVICE_MODULE_TYPES.find((e) => e.value === module.type)
  const Icon = iconForName(module.iconName, typeEntry?.Icon ?? File)
  const color = module.colorHex || '#64748b'

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <span
          className="flex size-8 items-center justify-center overflow-hidden rounded-md border bg-muted/40 text-foreground">
          {module.iconUrl ? (
            <img src={module.iconUrl} alt="" className="size-full object-contain"/>
          ) : (
            <Icon className="size-4" style={{color}}/>
          )}
        </span>
      </TooltipTrigger>
      <TooltipContent>{module.name ?? '—'}</TooltipContent>
    </Tooltip>
  )
}
